import { useHttpApi } from './mode';
import type { GameApi } from './types';
import { createHttpApi } from './http';
import { createMockApi } from './mock';

/**
 * Dev: mock, a menos que `.env.local` tenha `VITE_API_MODE=http`.
 * Produção (`vite build`): API real, a menos que `VITE_API_MODE=mock`.
 */
export const api: GameApi = useHttpApi ? createHttpApi() : createMockApi();

export * from './types';
